export default "__VITE_ASSET__e6$SXlAQ__"